<template>
    <div class="af-apply-with-accounts" v-if="$_jobApplication.apply_step===1">
        <div class="af-header-section">
            <div class="af-header-title afu-font-semibold afu-text-xs afu-leading-xs md:afu-text-4xl md:afu-leading-4xl afu-mb-2 afu-text-black">
                {{ $t('apply.title') }}
            </div>
            <div class="af-header-content afu-text-xl afu-leading-xl afu-mb-5 afu-text-black">
                {{ $t('apply.info') }}
            </div>
            <div class="af-apply-with-options afu-grid afu-grid-cols-1 md:afu-grid-cols-4 afu-gap-4">
                <Seek />
                <LinkedIn @onError="showError" />
                <Facebook
                    v-if="!$_me.id"
                    @onError="showError"
                />
                <Google
                    v-if="!$_me.id"
                    @onError="showError"
                />
            </div>
            <div class="af-apply-with-options afu-mt-5 afu-grid afu-grid-cols-1 md:afu-grid-cols-4 afu-gap-4">
                <Indeed />
            </div>
            <div
                v-if="!!response.message"
                class="af-apply-with-errors afu-my-4"
            >
                <C1Alert
                    :variant="response.variant"
                >
                    <span v-html="response.message" />
                </C1Alert>
            </div>
        </div>
        <hr class="afu-border afu-border-neutral afu-mt-10 afu-mb-10 md:afu-mt-8 md:afu-mb-8 afu-border-t-0 afu-border-l-0 afu-border-r-0 afu-border-solid">
    </div>
    <div class="af-apply-with-accounts" v-else>
        <LinkedIn @onError="showError" />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import C1Alert from '@/components/C1Components/C1Alert';
    import Seek from './Seek';
    import LinkedIn from './LinkedIn';
    import Facebook from './Facebook';
    import Google from './Google';
    import Indeed from './Indeed';

    export default {
        name: 'ApplyWithAccounts',

        components: {
            C1Alert,
            Seek,
            LinkedIn,
            Facebook,
            Google,
            Indeed,
        },

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_jobApplication: state => state.jobApplication,
            }),
        },

        methods: {
            showError(error) {
                this.response.variant = 'danger';
                this.response.message = error;
            },
        },
    };
</script>
